export const USER_UPDATE = 'USER_UPDATE';

export const userUpdate = (user) => {
  return {
    type: USER_UPDATE,
    current_user: user
  };
};